import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0274 = React.lazy(() => import('./symbols/0274_chat_message_comment_bubble'));
const Symbol0275 = React.lazy(() => import('./symbols/0275_chat_message_comment_bubble_typing'));
const Symbol0276 = React.lazy(() => import('./symbols/0276_chat_message_comment_bubble_add_new'));
const Symbol0277 = React.lazy(
  () => import('./symbols/0277_chat_message_comment_bubble_like_favorite')
);
const Symbol0278 = React.lazy(
  () => import('./symbols/0278_chat_message_comment_bubble_tweet_twitter')
);
const Symbol0279 = React.lazy(() => import('./symbols/0279_chat_message_comment_bubble'));
const Symbol0280 = React.lazy(
  () => import('./symbols/0280_chat_message_comment_bubble_reply_quote')
);
const Symbol0281 = React.lazy(
  () => import('./symbols/0281_chat_message_discussion_bubble_reply_conversation')
);
const Symbol0282 = React.lazy(() => import('./symbols/0282_chat_message_comment_bubble_cloud'));
const Symbol0283 = React.lazy(() => import('./symbols/0283_chat_message_comment_bubble_cloud'));
const Symbol0284 = React.lazy(() => import('./symbols/0284_message_text_like_favorite'));
const Symbol0285 = React.lazy(() => import('./symbols/0285_chat_message_quote_reply'));
const Symbol0286 = React.lazy(() => import('./symbols/0286_mobile_message_sms'));
const Symbol0287 = React.lazy(() => import('./symbols/0287_mobile_message_sms'));
const Symbol0288 = React.lazy(() => import('./symbols/0288_mobile_phone_call'));
const Symbol0289 = React.lazy(() => import('./symbols/0289_mobile_phone_call_ringing_nfc'));
const Symbol0290 = React.lazy(() => import('./symbols/0290_phone_telephone_contact'));
const Symbol0291 = React.lazy(() => import('./symbols/0291_phone_mobile_contact'));
const Symbol0292 = React.lazy(() => import('./symbols/0292_phone_contact'));
const Symbol0293 = React.lazy(() => import('./symbols/0293_phone_call_number_dialer'));
const Symbol0294 = React.lazy(() => import('./symbols/0294_phone_call_ringing'));
const Symbol0295 = React.lazy(() => import('./symbols/0295_phone_hold_call'));
const Symbol0296 = React.lazy(() => import('./symbols/0296_phone_call_contact'));
const Symbol0297 = React.lazy(() => import('./symbols/0297_address_book_contacts'));
const Symbol0298 = React.lazy(() => import('./symbols/0298_address_book_contacts'));
const Symbol0299 = React.lazy(() => import('./symbols/0299_address_book_contacts'));
const Symbol0300 = React.lazy(() => import('./symbols/0300_address_book_contacts'));
const Symbol0301 = React.lazy(() => import('./symbols/0301_address_book_contacts'));
const Symbol0302 = React.lazy(() => import('./symbols/0302_sim_card'));
const Symbol0303 = React.lazy(() => import('./symbols/0303_notification_badge'));
const Symbol0304 = React.lazy(
  () => import('./symbols/0304_chat_contact_support_help_conversation')
);
const Symbol0305 = React.lazy(
  () => import('./symbols/0305_chat_message_discussion_bubble_conversation')
);
const Symbol0306 = React.lazy(
  () => import('./symbols/0306_chat_message_discussion_bubble_conversation')
);
const Symbol0307 = React.lazy(
  () => import('./symbols/0307_chat_discussion_yes_no_pro_contra_conversation')
);
const Symbol0308 = React.lazy(() => import('./symbols/0308_support_help'));
const Symbol0309 = React.lazy(() => import('./symbols/0309_support_help_talk_call'));
const Symbol0310 = React.lazy(() => import('./symbols/0310_support_help_talk_call'));
const Symbol0311 = React.lazy(() => import('./symbols/0311_stamp'));
const Symbol0312 = React.lazy(() => import('./symbols/0312_post_stamp'));
const Symbol0313 = React.lazy(() => import('./symbols/0313_email_at_sign'));
const Symbol0314 = React.lazy(() => import('./symbols/0314_email_mail_post_card'));
const Symbol0315 = React.lazy(() => import('./symbols/0315_email_mail_post_send'));
const Symbol0316 = React.lazy(() => import('./symbols/0316_email_mail_post_open'));
const Symbol0317 = React.lazy(() => import('./symbols/0317_send_post_paper_plane'));
const Symbol0318 = React.lazy(() => import('./symbols/0318_email_attachment'));
const Symbol0319 = React.lazy(() => import('./symbols/0319_email_mail_post_card'));
const Symbol0320 = React.lazy(() => import('./symbols/0320_email_mail_post_card_sent_successful'));
const Symbol0321 = React.lazy(() => import('./symbols/0321_email_mail_post_at'));
const Symbol0322 = React.lazy(() => import('./symbols/0322_mail_post_box'));

export interface IProps {}

const Communication: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0274_chat_message_comment_bubble" symbol={<Symbol0274 />} />
      <LazySymbol id="0275_chat_message_comment_bubble_typing" symbol={<Symbol0275 />} />
      <LazySymbol id="0276_chat_message_comment_bubble_add_new" symbol={<Symbol0276 />} />
      <LazySymbol id="0277_chat_message_comment_bubble_like_favorite" symbol={<Symbol0277 />} />
      <LazySymbol id="0278_chat_message_comment_bubble_tweet_twitter" symbol={<Symbol0278 />} />
      <LazySymbol id="0279_chat_message_comment_bubble" symbol={<Symbol0279 />} />
      <LazySymbol id="0280_chat_message_comment_bubble_reply_quote" symbol={<Symbol0280 />} />
      <LazySymbol
        id="0281_chat_message_discussion_bubble_reply_conversation"
        symbol={<Symbol0281 />}
      />
      <LazySymbol id="0282_chat_message_comment_bubble_cloud" symbol={<Symbol0282 />} />
      <LazySymbol id="0283_chat_message_comment_bubble_cloud" symbol={<Symbol0283 />} />
      <LazySymbol id="0284_message_text_like_favorite" symbol={<Symbol0284 />} />
      <LazySymbol id="0285_chat_message_quote_reply" symbol={<Symbol0285 />} />
      <LazySymbol id="0286_mobile_message_sms" symbol={<Symbol0286 />} />
      <LazySymbol id="0287_mobile_message_sms" symbol={<Symbol0287 />} />
      <LazySymbol id="0288_mobile_phone_call" symbol={<Symbol0288 />} />
      <LazySymbol id="0289_mobile_phone_call_ringing_nfc" symbol={<Symbol0289 />} />
      <LazySymbol id="0290_phone_telephone_contact" symbol={<Symbol0290 />} />
      <LazySymbol id="0291_phone_mobile_contact" symbol={<Symbol0291 />} />
      <LazySymbol id="0292_phone_contact" symbol={<Symbol0292 />} />
      <LazySymbol id="0293_phone_call_number_dialer" symbol={<Symbol0293 />} />
      <LazySymbol id="0294_phone_call_ringing" symbol={<Symbol0294 />} />
      <LazySymbol id="0295_phone_hold_call" symbol={<Symbol0295 />} />
      <LazySymbol id="0296_phone_call_contact" symbol={<Symbol0296 />} />
      <LazySymbol id="0297_address_book_contacts" symbol={<Symbol0297 />} />
      <LazySymbol id="0298_address_book_contacts" symbol={<Symbol0298 />} />
      <LazySymbol id="0299_address_book_contacts" symbol={<Symbol0299 />} />
      <LazySymbol id="0300_address_book_contacts" symbol={<Symbol0300 />} />
      <LazySymbol id="0301_address_book_contacts" symbol={<Symbol0301 />} />
      <LazySymbol id="0302_sim_card" symbol={<Symbol0302 />} />
      <LazySymbol id="0303_notification_badge" symbol={<Symbol0303 />} />
      <LazySymbol id="0304_chat_contact_support_help_conversation" symbol={<Symbol0304 />} />
      <LazySymbol id="0305_chat_message_discussion_bubble_conversation" symbol={<Symbol0305 />} />
      <LazySymbol id="0306_chat_message_discussion_bubble_conversation" symbol={<Symbol0306 />} />
      <LazySymbol
        id="0307_chat_discussion_yes_no_pro_contra_conversation"
        symbol={<Symbol0307 />}
      />
      <LazySymbol id="0308_support_help" symbol={<Symbol0308 />} />
      <LazySymbol id="0309_support_help_talk_call" symbol={<Symbol0309 />} />
      <LazySymbol id="0310_support_help_talk_call" symbol={<Symbol0310 />} />
      <LazySymbol id="0311_stamp" symbol={<Symbol0311 />} />
      <LazySymbol id="0312_post_stamp" symbol={<Symbol0312 />} />
      <LazySymbol id="0313_email_at_sign" symbol={<Symbol0313 />} />
      <LazySymbol id="0314_email_mail_post_card" symbol={<Symbol0314 />} />
      <LazySymbol id="0315_email_mail_post_send" symbol={<Symbol0315 />} />
      <LazySymbol id="0316_email_mail_post_open" symbol={<Symbol0316 />} />
      <LazySymbol id="0317_send_post_paper_plane" symbol={<Symbol0317 />} />
      <LazySymbol id="0318_email_attachment" symbol={<Symbol0318 />} />
      <LazySymbol id="0319_email_mail_post_card" symbol={<Symbol0319 />} />
      <LazySymbol id="0320_email_mail_post_card_sent_successful" symbol={<Symbol0320 />} />
      <LazySymbol id="0321_email_mail_post_at" symbol={<Symbol0321 />} />
      <LazySymbol id="0322_mail_post_box" symbol={<Symbol0322 />} />
    </>
  );
});

Communication.displayName = 'Communication';

export default Communication;
